export default {
  data: function data() {
    return {};
  },
  props: ["initialData"]
};